/**
 * Firestore rejects undefined anywhere in document data.
 * Strips undefined keys recursively (objects and arrays of objects).
 */
export function omitUndefinedDeep(value) {
  if (value === undefined) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(omitUndefinedDeep);
  }
  if (value !== null && typeof value === 'object') {
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      if (v !== undefined) {
        out[k] = omitUndefinedDeep(v);
      }
    }
    return out;
  }
  return value;
}
